import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type { InputHTMLAttributes } from 'react';
type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'onClick'> & {
  id?: string;
  hasError?: boolean;
};
function CheckboxInput(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    const {
      className: t1,
      hasError: _hasError,
      ...t2
    } = t0;
    className = t1;
    props = t2;
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cx("h-4 w-4 cursor-pointer rounded-[3px] border-gray-300 text-secondary accent-secondary", "checked:border-secondary checked:bg-secondary checked:ring-transparent focus:ring-transparent", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <input {...props} type="checkbox" className={t1} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export const Checkbox: React.FC<CheckboxProps & {
  label?: React.ReactNode;
}> = t0 => {
  const $ = _c(14);
  let label;
  let props;
  if ($[0] !== t0) {
    ({
      label,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = label;
    $[2] = props;
  } else {
    label = $[1];
    props = $[2];
  }
  if (!label) {
    let t1;
    if ($[3] !== props) {
      t1 = <CheckboxInput {...props} />;
      $[3] = props;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  const t1 = props.id;
  let t2;
  if ($[5] !== props) {
    t2 = <CheckboxInput {...props} />;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cx("text-primary");
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== label) {
    t4 = <span className={t3}>{label}</span>;
    $[8] = label;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== props.id || $[11] !== t2 || $[12] !== t4) {
    t5 = <label htmlFor={t1} className="flex cursor-pointer items-center gap-3">{t2}{t4}</label>;
    $[10] = props.id;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};